<template>
  <div style="position: relative;">
    <k-data-table :headers="headers" :items="SettingsList" :pagination.sync="pagination" :rows-per-page-items="[5, 15, 25, 50, 100, { text: 'All', value: -1 }]">
      <template slot="headerCell" slot-scope="props">
          <div v-if="props.header.text == 'Type'">
            <k-menu
            offset-y
            :close-on-content-click="false">
                <template slot="activator" slot-scope="{ on }" style="padding: 20px;">
                  <k-btn flat v-on="on" >
                    <span style="display: flex; align-items: center;">
                      <div style="margin-right: 25px; margin-left: 35px;">Type</div>
                      <k-icon small>filter_list</k-icon>
                    </span>
                  </k-btn>
                </template>
                <div style="padding: 10px">
                  <div
                    v-for="(item, index) in menu_items"
                    :key="index"
                    style="padding: 0px; margin: 0px;"
                  >
                    <span>
                      <k-checkbox
                        v-model="type_filters"
                        :label="item.label"
                        :input-value="item.value"
                        color="deep-orange"
                        style="padding: 0px; margin: 0px; height: 28px; justify-content:left;"
                      ></k-checkbox>
                    </span>
                  </div>
                </div>
            </k-menu>
          </div>

          <span v-else>
              <td>{{ props.header.text }}</td>
          </span>
      </template>
      <template slot="items" slot-scope="props">
        <tr @click.stop="open_edit_setting(props.item.id)">
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.title }}</td>
          <td>{{ props.item.type }}</td>
          <td>{{ props.item.inserted_at | format("%d.%m.%Y %H:%M:%S") }}</td>
          <td>{{ props.item.updated_at | format("%d.%m.%Y %H:%M:%S") }}</td>
        </tr>
      </template>
    </k-data-table>
    <action-buttons @add="open_add_setting"></action-buttons>
  </div>
</template>

<script>
import datelib from '@/lib/date.js';
import moment from 'moment';
import SettingsModel from '@/models/settings.js'
import ActionButtons from '@/components/ActionButtons.vue'

export default {
  components: {
    ActionButtons
  },
  filters: datelib,
  data () {
    return {
      headers: [
        { text: 'Name', value: 'name', align: 'left' },
        { text: 'Title', value: 'title', align: 'left'},
        { text: 'Type', value: 'type', align: 'left', sortable: false},
        { text: 'Created at', value: 'inserted_at', align: 'left' },
        { text: 'Updated at', value: 'updated_at', align: 'left' }
      ],
      menu_items: SettingsModel.types(),

      pagination: {
        sortBy: 'name',
        descending: true,
        rowsPerPage: 25
      },
      type_filters: []
    }
  },
  computed: {
    search_text () {
      return this.$store.state.search_text;
    },
    SettingsList () {
      var ret = Object.values(this.$store.state.settings);
      var search = (this.search_text || "").toLowerCase();
      var type_filters = this.type_filters;

      if (search.length > 0) {
        ret = _.filter(ret, function(setting) {
          ret = false;
          if (setting.name.toLowerCase().includes(search)) ret = true;
          if (setting.type.toLowerCase().includes(search)) ret = true;
          return ret;
        })
      }

      if (type_filters.length > 0) {
        ret = _.filter(ret, function(setting) {
          ret = false;
          if (type_filters.includes(setting.type)) {
            ret = true;
          }
          return ret;
        })
      }
      return ret;
    }
  },
  mounted () {
  },
  methods: {
    open_add_setting () {
      this.$router.push("/settings/settings/new")
    },
    open_edit_setting (id) {
      this.$router.push("/settings/settings/edit/"+id)
    }
  }
}
</script>
